/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RodzajCzlonuTyp {
  Pierwszy = 'PIERWSZY',
  Drugi = 'DRUGI',
  Trzeci = 'TRZECI'
}
